import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Col, Container, Row } from 'reactstrap';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import { stringify, parse } from 'query-string';

import DeleteIcon from 'mdi-react/DeleteIcon';
import PencilIcon from 'mdi-react/PencilIcon';
import BriefcaseIcon from 'mdi-react/BriefcaseIcon';
import ClockTimeFourIcon from 'mdi-react/ClockTimeFourIcon';
import ArrowRightThinCircleOutlineIcon from 'mdi-react/ArrowRightThinCircleOutlineIcon';
import CurrencyUsdIcon from 'mdi-react/CurrencyUsdIcon';
import ThumbUpOutlineIcon from 'mdi-react/ThumbUpOutlineIcon';
import PencilBoxIcon from 'mdi-react/PencilBoxIcon';
import CloseCircleOutlineIcon from 'mdi-react/CloseCircleOutlineIcon';


import roles from '../../../config/roles';
import { deleteUser, postDelaySalaryUser, putActivateUser, putDeactivateUser, putUserSalary } from '../../../utils/api';
import { getUsersFetchingAction } from '../../../redux/actions/usersActions';
import { loginAsError, loginAsRequest } from '../../../redux/actions/authActions';

import { columns } from './components/DataUsersColumns';
import DataReactTable from '../../Tables/DataTable/components/DataReactTable';
import UsersFilterForm from './components/UsersFilterForm/UsersFilterForm';
import ConfirmModal from '../../../shared/components/customComponents/CustomConfirmModal/ConfirmModal';

import CustomModal from '../../../shared/components/customComponents/CustomModal/CustomModal';
import DelaySalaryModalForm from './components/DelaySalaryModalForm/DelaySalaryModalForm';

const TableButton = ({isActive, setActivateId, id, setActivateModal, setDeactivateId, setDeactivateModal}) => {
  const [isHovered, setIsHovered] = useState(false);

  const getMetaData = () => {
    const obj = {
      btnLabel: "",
      btnColor: ""
    }
    if(isActive) {
      obj.btnLabel = "Activated";
      obj.btnColor = "success";
    }
    if(isHovered && isActive) {
      obj.btnLabel = "Deactivate";
      obj.btnColor = "danger";
    }

    if(!isActive) {
      obj.btnLabel = "Deactivated";
      obj.btnColor = "danger";
    }
    if(!isActive && isHovered) {
      obj.btnLabel = "Activate";
      obj.btnColor = "success";
    }

    return obj;
  }

  const {btnLabel, btnColor} = getMetaData();

  return (
    <Button
      className="icon table-button"
      size="sm" 
      color={btnColor}
      style={{ padding: "5px 10px", minWidth: "121px", width: "100%" }}
      onMouseLeave={() => setIsHovered(false)}
      onMouseOver={() => setIsHovered(true)}
      onClick={() => {
        if (!isActive) {
          setActivateId(id);
          setActivateModal(true);
        } else {
          setDeactivateId(id);
          setDeactivateModal(true);
        }
      }}>
      {btnColor === "success" ? (<ThumbUpOutlineIcon />) : (<CloseCircleOutlineIcon />)}
      {btnLabel}
    </Button>
  )
}

const InputOfficialSalary = ({value, onChange, onBlur}) => {
  return (
    <input
      type='text'
      value={value}
      style={{border: 0, outline: "1px solid gray", width: "50px", padding: "4px 4px 1px 3px" }}
      onChange={onChange}
      onBlur={onBlur}
    />
  )
}

const EditSalaryIcon = ({toggleInput }) => {
  return (
    <PencilBoxIcon className="edit-salary" onClick={toggleInput} style={{cursor: "pointer", padding: 0}} size={18} color="#b1c3c8" />
  )
}

const Users = () => {
  const { t } = useTranslation('common');
  const { users, errors, totalRecords } = useSelector(state => state.users);
  const authUser = useSelector(state => state.auth.user);
  const loginAsErrorMessage = useSelector(state => state.auth.loginAsError);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const parsedQuery = parse(location.search);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [currentPage, setCurrentPage] = useState(+parsedQuery?.start || 1);
  const [pageLimit, setPageLimit] = useState(+parsedQuery?.limit || 10);
  const [query, setQuery] = useState({ start: 0, limit: 10, search_query: '', role: '', is_active: null });
  const [deleteId, setDeleteId] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [failedDeleteModal, setFailedDeleteModal] = useState(false);
  const [successDeletedModal, setSuccessDeletedModal] = useState(false);
  const [activateId, setActivateId] = useState(null);
  const [activateModal, setActivateModal] = useState(false);
  const [messageActivateError, setMessageActivateError] = useState('');
  const [failedActivateModal, setFailedActivateModal] = useState(false);
  const [successActivateModal, setSuccessActivateModal] = useState(false);
  const [deactivateId, setDeactivateId] = useState(null);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [messageDeactivateError, setMessageDeactivateError] = useState('');
  const [failedDeactivateModal, setFailedDeactivateModal] = useState(false);
  const [successDeactivateModal, setSuccessDeactivateModal] = useState(false);
  const [delaySalaryModal, setDelaySalaryModal] = useState(false);
  const [delaySalaryId, setDelaySalaryId] = useState(null);
  const [salaryUser, setSalaryUser] = useState(null);
  const [salaryNameUser, setSalaryUserName] = useState('');
  const [messageDelaySalaryError, setMessageDelaySalaryError] = useState('');
  const [failedDelaySalaryModal, setFailedDelaySalaryModal] = useState(false);
  const [successDelaySalaryModal, setSuccessDelaySalaryModal] = useState(false);
  const [toggleInputSalary, setToggleInputSalary] = useState({});
  const [messageChangeSalaryError, setMessageChangeSalaryError] = useState('');
  const [failedChangeSalaryModal, setFailedChangeSalaryModal] = useState(false);
  const [successChangeSalaryModal, setSuccessChangeSalaryModal] = useState(false);
  const [order, setOrder] = useState({name: 'id', desc: 'desc'});

  const handleToggleInputSalary = (id) => {
    setToggleInputSalary((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const [editedSalary, setEditedSalary] = useState({});

  const handleInputChange = (id, newValue) => {
    setEditedSalary((prevState) => ({
      ...prevState,
      [id]: newValue,
    }));
  };

  const handleInputBlur = (id) => {
    const newValue = editedSalary[id];

    putUserSalary(id, newValue, authUser.accessToken).then(res => {
      if(res.data.success) {
        setSuccessChangeSalaryModal(!successChangeSalaryModal);
        setToggleInputSalary(false);
      } else {
        setMessageChangeSalaryError(res.data.errors[0].message);
        setFailedChangeSalaryModal(!failedDelaySalaryModal);
      }
    })
  };

  useEffect(() => {
    // Refresh state after back to admin redirection
    if (location.state?.refresh) {
      setRefreshCounter(0);
      setCurrentPage(1);
      setPageLimit(10);
      setQuery({ start: 0, limit: 10, search_query: '', role: '', is_active: null });
    }
  }, [location.state]);

  useEffect(() => {
    const updatedQuery = {
      ...query,
      start: (currentPage - 1) * pageLimit,
      limit: pageLimit
    };

    navigate(`${location.pathname}?${stringify({start: currentPage, limit: pageLimit}, {arrayFormat: 'comma'})}`);
    dispatch(getUsersFetchingAction(updatedQuery, order));
  }, [currentPage, pageLimit, dispatch, query, refreshCounter, location.pathname, navigate, order]);

  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const handleChangePage = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangePageSize = (newSize) => {
    setCurrentPage(1);
    setPageLimit(newSize);
  };

  const applyFilterForm = (value) => {
    return setQuery({...query, search_query: value?.search, role: value?.selectRoles?.value, is_active: value?.selectStatus?.value});
  }

  const resetFilterForm = () => {
    return setQuery({...query, search_query: '', role: '', is_active: null});
  }

  const checkHiddenColumns = () => {
    if(['PM', 'DEV', 'CLIENT'].includes(authUser.role)) {
      return ['role', 'status', 'salary', 'min_non_upwork_sale_rate', 'min_upwork_sale_rate', 'optimal_sale_rate', 'vacation_days', 'actions'];
    } else if (['FIN'].includes(authUser.role)) {
      return ['min_non_upwork_sale_rate', 'min_upwork_sale_rate', 'optimal_sale_rate', 'actions'];
    } else if (['SALES'].includes(authUser.role)) {
      return ['salary', 'vacation_days'];
    }

    return [];
  }

  const handleDeleteUser = () => {
    deleteUser(deleteId, authUser.accessToken).then(res => {
      if(res.data.success) {
        setSuccessDeletedModal(!successDeletedModal);
      } else {
        setMessageError(res.data.errors[0].message);
        setFailedDeleteModal(!failedDeleteModal);
      }
    })
  }

  const handleActivateUser = () => {
    putActivateUser(activateId, authUser.accessToken).then(res => {
      if(res.data.success) {
        setSuccessActivateModal(!successActivateModal);
        setRefreshCounter(refreshCounter + 1);
      } else {
        setMessageActivateError(res.data.errors[0].message);
        setFailedActivateModal(!failedActivateModal);
      }
    })
  }

  const handleDeactivateUser = () => {
    putDeactivateUser(deactivateId, authUser.accessToken).then(res => {
      if(res.data.success) {
        setSuccessDeactivateModal(!successDeactivateModal);
        setRefreshCounter(refreshCounter + 1);
      } else {
        setMessageDeactivateError(res.data.errors[0].message);
        setFailedDeactivateModal(!failedDeactivateModal);
      }
    })
  }

  const handleSubmitDelaySalaryModalForm = (value) => {
    postDelaySalaryUser(value, delaySalaryId, authUser.accessToken).then(res => {
      if(res.data.success) {
        setDelaySalaryModal(false);
        setSuccessDelaySalaryModal(!successDelaySalaryModal);
      } else {
        setMessageDelaySalaryError(res.data.errors[0].message);
        setFailedDelaySalaryModal(!failedDelaySalaryModal);
      }
    })
  }

  return (
    <Container>
      <Row>
        <CustomModal
            successModal={loginAsErrorMessage !== ''}
            toggleCloseModal={() => {
              dispatch(loginAsError(''));
            }}
            textModal={loginAsErrorMessage}
            color={"danger"}
          />
        {
          authUser.role === roles.ADMIN ? (
            <Col className="col-12 d-flex justify-content-end">
              <button className="btn btn-success" onClick={() => navigate("/management/users/add", {
                state: {
                  prevQuery: [{
                    query: location.search,
                    path: location.pathname,
                  }]
                },
              }
              )}>Create User</button>
            </Col>
          ) : null
        }
        <Col className="col-12 pl-0 pr-0">
          <UsersFilterForm
            userRoles={users.map(u => { return { id: u.role, label: u.role }})}
            onSubmit={applyFilterForm}
            resetForm={resetFilterForm}
            userRole={authUser.role}
          />
        </Col>
        <Col>
          <DataReactTable
            tableName={'Users'}
            sortTable={true}
            search={false}
            classList={"table-users"}
            explanation={authUser.role === roles.SALES || authUser.role === roles.ADMIN}
            pagination={{
              onChangePageSize: handleChangePageSize,
              onChangePage: handleChangePage,
              currentPage,
              totalRecords,
              pageLimit,
            }}
            onSortChange={(sortBy) => {
              const { id, desc } = sortBy[0] || {};
              if (!id) return;

              const computedName = (id === "min_non_upwork_sale_rate" || id === "min_upwork_sale_rate" || id === "optimal_sale_rate") ? "salary" : id;
              const newOrder = { name: computedName, desc: desc ? 'desc' : 'asc' };

              if (order.name !== newOrder.name || order.desc !== newOrder.desc) {
                setOrder(newOrder);
              }
            }}
            emptyStateMessage={t('empty_states.users')}
            reactTableData={{
              tableHeaderData: _.filter(columns, c => !checkHiddenColumns().includes(c.accessor)),
              tableRowsData: users?.map((c) => {
                const isInputVisible = toggleInputSalary[c.id] || false;

                return {
                  ...c,
                  id: `${c.id}`,
                  first_name: `${c.first_name} ${c.last_name}`,
                  date_signup: c.joined,
                  is_active: <div className="status">{c.is_active ? 'Active' : 'Blocked'} <br/> <span>{c.last_login}</span></div>,
                  salary: <>{c.salary} {!!c?.delayed_salary?.value ? (
                    <>
                      <ReactTooltip id={`usdIcon-${c.id}`} type="dark">
                        <span style={{ color: 'white' }}>
                          {`${t("reactTooltips.salaryWillBe")} $${c?.delayed_salary?.value} ${t("reactTooltips.on")} ${monthNames[Number(c?.delayed_salary?.month) - 1]}`}
                        </span>
                      </ReactTooltip>
                      <span className="wrapper-usdIcon" data-tip data-for={`usdIcon-${c.id}`}><CurrencyUsdIcon className="p-0" color="#fff" size={16} /></span>
                    </>
                    ) : null} <br/>
                    {authUser.role === roles.ADMIN || authUser.role === roles.FIN ? <>{isInputVisible ?
                      (<InputOfficialSalary
                          value={editedSalary[c.id] || c.official_salary}
                          onChange={(e) => handleInputChange(c.id, e.target.value)}
                          onBlur={(e) => handleInputBlur(c.id, e.target.value)}/>
                      ) : Number(c.official_salary)} <EditSalaryIcon toggleInput={() => handleToggleInputSalary(c.id)} /></> : Number(c.official_salary)} <br/>
                    {c.salary_up}</>,
                  min_non_upwork_sale_rate: `$ ${c.min_non_upwork_sale_rate} h`,
                  min_upwork_sale_rate: `$ ${c.min_upwork_sale_rate} h`,
                  optimal_sale_rate: `$ ${c.optimal_sale_rate} h`,
                  vacation_days: `${c.vacation_days_available} (${c.vacation_days})`,
                  actions:
                    <>
                      {
                        authUser.role !== roles.SALES ? (
                          <>
                            <ReactTooltip id="deleteIcon" type="dark">
                              <span style={{ color: 'white' }}>
                                {t("reactTooltips.delete")}
                              </span>
                            </ReactTooltip>
                            <button
                              style={{border: 0, background: "transparent"}}
                              data-tip
                              data-for="deleteIcon"
                            >
                              <DeleteIcon
                                color="#b1c3c8"
                                size={18}
                                onClick={() => {
                                  setDeleteId(c.id)
                                  setConfirmModal(true)
                                }}
                              />
                            </button>
                            <ReactTooltip id="editIcon" type="dark">
                              <span style={{ color: 'white' }}>
                                {t("reactTooltips.edit")}
                              </span>
                            </ReactTooltip>
                            <button
                              data-tip
                              data-for="editIcon"
                              style={{border: 0, background: "transparent"}}
                              onClick={() => navigate(`/management/users/${c.id}/edit`, {
                                state: {
                                  prevQuery: [{
                                    query: location.search,
                                    path: location.pathname,
                                  }]
                                },
                              })}
                            >
                              <PencilIcon color="#b1c3c8" size={18} />
                            </button>
                          </>
                        ) : null
                      }

                      <ReactTooltip id="caseIcon" type="dark">
                        <span style={{ color: 'white' }}>
                          {t("reactTooltips.workHistory")}
                        </span>
                      </ReactTooltip>
                      <button
                        style={{border: 0, background: "transparent"}}
                        data-tip
                        data-for="caseIcon"
                      >
                        <BriefcaseIcon
                          color="#b1c3c8"
                          size={18}
                          onClick={() => {
                            navigate(`/management/users/${c.id}/work-history`, {
                              state: {
                                prevQuery: [{
                                  query: location.search,
                                  path: location.pathname,
                                }]
                              },
                            });
                          }}
                        />
                      </button>

                      {
                        authUser.role !== roles.SALES ? (
                          <>
                            <ReactTooltip id="clockIcon" type="dark">
                              <span style={{ color: 'white' }}>
                                {t("reactTooltips.delaySalary")}
                              </span>
                            </ReactTooltip>
                            <button
                              style={{border: 0, background: "transparent"}}
                              data-tip
                              data-for="clockIcon"
                            >
                              <ClockTimeFourIcon
                                color="#b1c3c8"
                                size={18}
                                onClick={() => {
                                  setDelaySalaryId(c.id);
                                  setSalaryUser(Number(c.salary.replace(/,/g, '')));
                                  setSalaryUserName(`${c.first_name} ${c.last_name}`);
                                  setDelaySalaryModal(true);
                                }}
                              />
                            </button>
                            {
                              c.role !== "GUEST" && authUser.role === roles.ADMIN ? (
                                <>
                                  <ReactTooltip id="arrowRightIcon" type="dark">
                                    <span style={{ color: 'white' }}>
                                      {t("reactTooltips.loginAs")}
                                    </span>
                                  </ReactTooltip>
                                  <button
                                    style={{border: 0, background: "transparent"}}
                                    data-tip
                                    data-for="arrowRightIcon"
                                  >
                                    <ArrowRightThinCircleOutlineIcon
                                      color="#b1c3c8"
                                      size={18}
                                      onClick={() => {
                                        dispatch(loginAsRequest(c.id));
                                      }}
                                    />
                                  </button>
                                </>
                              ) : null
                            }
                          </>
                        ) : null
                      }
                      {
                        authUser.role !== roles.SALES ? (
                          <TableButton
                            isActive={!!c.is_active}
                            id={c.id}
                            setActivateId={setActivateId}
                            setActivateModal={setActivateModal}
                            setDeactivateId={setDeactivateId}
                            setDeactivateModal={setDeactivateModal}
                          />
                        ) : null
                      }
                    </>,
                };
              }),
            }}
          />
          {
            errors ? (<div>{errors}</div>) : null
          }
          {
            delaySalaryModal && (<DelaySalaryModalForm
                                    toggle={() => setDelaySalaryModal(!delaySalaryModal)}
                                    setDelaySalaryModal={setDelaySalaryModal}
                                    modal={delaySalaryModal}
                                    onSubmit={handleSubmitDelaySalaryModalForm}
                                    salaryUser={salaryUser}
                                    salaryNameUser={salaryNameUser}
                                />)
          }
          <ConfirmModal
            color="danger"
            btn="Default"
            message={`Are you sure you want to delete user #${deleteId}?`}
            toggle={() => setConfirmModal(!confirmModal)}
            modal={confirmModal}
            onNext={handleDeleteUser}
          />
          <CustomModal
            successModal={failedDeleteModal}
            toggleCloseModal={() => setFailedDeleteModal(!failedDeleteModal)}
            textModal={messageError}
            color={"danger"}
          />
          <CustomModal
            successModal={successDeletedModal}
            toggleCloseModal={() => {
              setSuccessDeletedModal(!successDeletedModal);
              setRefreshCounter(refreshCounter + 1);
            }}
            textModal={`User №${deleteId} was successfully deleted!`}
            color={"success"}
          />
          <ConfirmModal
            color="primary"
            btn="Default"
            message={`Are you sure you want to activate user #${activateId}?`}
            toggle={() => setActivateModal(!activateModal)}
            modal={activateModal}
            onNext={handleActivateUser}
          />
          <CustomModal
            successModal={failedActivateModal}
            toggleCloseModal={() => setFailedActivateModal(!failedActivateModal)}
            textModal={messageActivateError}
            color={"danger"}
          />
          <ConfirmModal
            color="primary"
            btn="Default"
            message={`Are you sure you want to deactivate user #${deactivateId}?`}
            toggle={() => setDeactivateModal(!deactivateModal)}
            modal={deactivateModal}
            onNext={handleDeactivateUser}
          />
          <CustomModal
            successModal={failedDeactivateModal}
            toggleCloseModal={() => setFailedDeactivateModal(!failedDeactivateModal)}
            textModal={messageDeactivateError}
            color={"danger"}
          />
          <CustomModal
            successModal={failedDelaySalaryModal}
            toggleCloseModal={() => setFailedDelaySalaryModal(!failedDelaySalaryModal)}
            textModal={messageDelaySalaryError}
            color={"danger"}
          />
          <CustomModal
            successModal={successDelaySalaryModal}
            toggleCloseModal={() => {
              setSuccessDelaySalaryModal(!successDelaySalaryModal);
              setRefreshCounter(refreshCounter + 1);
            }}
            textModal={`Salary with delay for user №${delaySalaryId} was set successfully!`}
            color={"success"}
          />
          <CustomModal
            successModal={failedChangeSalaryModal}
            toggleCloseModal={() => setFailedChangeSalaryModal(!failedChangeSalaryModal)}
            textModal={messageChangeSalaryError}
            color={"danger"}
          />
          <CustomModal
            successModal={successChangeSalaryModal}
            toggleCloseModal={() => {
              setSuccessChangeSalaryModal(!successChangeSalaryModal);
              setRefreshCounter(refreshCounter + 1);
            }}
            textModal={`Official salary was successfully changed!`}
            color={"success"}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Users;
